import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ModerationService } from 'src/app/services/moderation.service';
import {map, catchError} from 'rxjs/operators';
import { error } from 'protractor';
import { EncryptionService } from 'src/app/services/encryption.service';

@Injectable({
  providedIn: 'root'
})
export class CheckLoginGuard implements CanActivate {

  constructor(private router : Router, private moderationService : ModerationService,private encryptService:EncryptionService){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    this.moderationService.testWebService()
    .subscribe( value => {
      if(value["status"] !== "success"){
        console.log(value)
        if( parseInt(value["cause"]) === 0 ) { //=> Si pas de session

          localStorage.clear();
          this.router.navigate(["/login"]);
          return false;
        } else if (parseInt(value['cause']) === 1) { //=> Si token expiré
          let user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
          user['token'] = value["token"]; //=> on met le nouveau token
          localStorage.setItem("user", this.encryptService.encrypt(JSON.stringify(user))); 

          return true;
        }

        return false;

      }   
      return true;
    });

    return true;

  }
  
}
